import React from "react";

const SuccessIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M27.2884918,13.9879505 L29.0933441,15.9510143 L16.9733159,27.0942386 L11.1752969,21.5921696 L13.010901,19.6578304 L17.0021073,23.4453122 L27.2884918,13.9879505 Z M19.999999,34.9999981 C11.7124993,34.9999981 4.9999998,28.2874985 4.9999998,19.999999 C4.9999998,11.7124993 11.7124993,4.9999998 19.999999,4.9999998 C28.2874985,4.9999998 34.9999981,11.7124993 34.9999981,19.999999 C34.9999981,28.2874985 28.2874985,34.9999981 19.999999,34.9999981 Z"
        id="path-1"
      />
    </defs>
    <g id="Alert/Mixin/Icon/Success" fill="none" fillRule="evenodd">
      <g id="Icon/Alert/Sucess">
        <mask id="mask-2" fill="#fff">
          <use xlinkHref="#path-1" />
        </mask>
        <use id="Fill-2" fill="#000" xlinkHref="#path-1" />
        <g id="Colors/Green-Copy-2" mask="url(#mask-2)" fill="#05A670">
          <rect id="foo️" width="40" height="40" />
        </g>
      </g>
    </g>
  </svg>
);

export default SuccessIcon;
